import React, { /*useCallback, useState,*/ useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {t} from 'i18next'
import DataTable from 'react-data-table-component'
import { FormGroup, Button } from 'reactstrap'
import moment from 'moment'

import { customStyles, displayDate, isNull } from '../../../izUtils'
import DictionaryInfoButton from '../../dictionary/DictionaryInfoButton'

const UserList = ({data, filters, reset2fa}) => {
    const { userId } = useParams()
    const Navigate = useNavigate()

    const handleRowClick = (state) => {
        Navigate('/users/' + state.id)
    }

    // This loops through rows and creates them
    const tableColumns = useMemo(() => {
        let columns = [
            {
                name: t('table.email'),
                selector: row => row.email,
                sortable: true,
                cell: row => {
                    if (userId === row.id) return <div className="clickableRow" onClick={() => handleRowClick(row)}>{row.email}</div>
                    return row.email
                }
            },
            {
                name: t('table.type'),
                selector: row => row.type,
                sortable: true,
                cell: row => {
                    if (userId === row.id) return <div className="clickableRow" onClick={() => handleRowClick(row)}>{row.type}</div>
                    return row.type
                }
            },
        ]

        if (filters.tabs.value === 'users') {
            columns.push(
                {
                    name: <div className='d-flex align-items-center'>
                            {t('table.unseen_requests')}
                            <DictionaryInfoButton code="users.table.unseen_requests" id="users.table.unseen_requests" color="#ffffff" />
                        </div>,
                    selector: row => row.unseen_requests,
                    sortable: false,
                    cell: row => {
                        if (userId === row.id) return <div className="clickableRow" onClick={() => handleRowClick(row)}>{row.unseen_requests !== 0 ? row.unseen_requests : ''}</div>
                        return row.unseen_requests !== 0 ? row.unseen_requests : '';
                    }
                },
                {
                    name: t('table.2fa'),
                    sortable: false,
                    cell: row => {
                        return <Button color="primary" className="btn-sm mt-2 me-2" onClick={() => reset2fa(row)}>{t('2faReset')}</Button>
                    }
                },
            )
        } else {
            columns.push(
                {
                    name: <div className='d-flex align-items-center'>
                            {t('table.email_verified_at')}
                            <DictionaryInfoButton code="users.table.email_verified_at" id="users.table.email_verified_at" />
                        </div>,
                    selector: row => row.email_verified_at,
                    sortable: false,
                    cell: row => {
                        if (userId === row.id) return <div className="clickableRow" onClick={() => handleRowClick(row)}>{!isNull(row.email_verified_at) ? displayDate(moment.utc(row.email_verified_at)) : ''}</div>
                        return !isNull(row.email_verified_at) ? displayDate(moment.utc(row.email_verified_at)) : '';
                    }
                },
            )
        }

        return columns;
    }, [userId, filters]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FormGroup>
            <DataTable
                columns={tableColumns}
                data={data}
                customStyles={customStyles}
                onRowClicked={handleRowClick}
            />
        </FormGroup>
    )
}

export default UserList